import { Store } from 'vuex';

export let _store: Store<any>;
export const set$store = (store: any) => {
  _store = store;
};



// WEBPACK FOOTER //
// ./src/tools/declare/global/$store.ts